/**
 * Hook to determine if CardV2 should be used for a given card.
 */

import { useMemo } from 'react';
import { CardSchema, CardTypeOptions } from '../../../constants/graphqlTypes';

/**
 * Hook to determine if CardV2 should be used for a given card.
 *
 * CardV2 now handles ALL Card-type items:
 * - Canonical content cards → media-type cards (BookCard, MovieCard, etc.)
 * - Everything else → layout cards (StandardCard, FullBleedCard, ImmersiveCard)
 *
 * @param card - The card to check
 * @returns Whether to use CardV2 for this card
 */
export function useCardV2Enabled(card: CardSchema): boolean {
  return useMemo(() => {
    return card.type === CardTypeOptions.Card;
  }, [card]);
}

export default useCardV2Enabled;
